import {combineReducers} from '@reduxjs/toolkit';
import {combineEpics} from 'redux-observable';
import {BootstrapEpics, bootstrapReducer} from './controls/bootstrap.slice';
import {LoginEpics, loginReducer} from './controls/LoginEpic';
import { ControlEpics, controlReducer } from './slice/controlSlice';
import { projectReducer } from './slice/projectSlice';

const rootReducer = combineReducers({
    login: loginReducer,
    bootstrap: bootstrapReducer,
    control: controlReducer,
    project: projectReducer
});

export const rootEpic = combineEpics(...LoginEpics, ...BootstrapEpics, ...ControlEpics);
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
